import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

// @mui icons
import Icon from "@mui/material/Icon";

const menus = (): CloudPremisePluginMenu[] => {
    return [
        {
            type: "menu_item",
            name: "Form",
            key: "forms",
            icon: <Icon fontSize="medium">dynamic_form</Icon>,
            route: "/forms/home",
            privacy: "private",
        },
    ];
};

export default menus;